/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-operations-undo': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M15 9.3c1.5 0 2.8 1.3 2.8 2.7 0 1.5-1.3 2.7-2.8 2.7h-4V16h4c2.3 0 4-1.7 4-4 0-2.2-1.8-4-4-4H3.4l2.5-2.5-.9-.9-4 4 4 4 .9-.9-2.5-2.4H15z"/>'
  }
})
